module.exports = __webpack_public_path__ + "static/media/icon-13.940c732e.png";